/* eslint-disable */
/* Auto-managed translation source — English (source of truth).
   Keep keys in sync across en.json / fr.json / de.json. */
const en = {
  common: {
    entity: "Quantum Capital Management S.A.",
    entity_short: "QUANTUM",
    city: "Luxembourg",
    email: "office@qcmlux.com"
  },
  hero: {
    scroll: "Scroll"
  },
  hero_cinematic: {
    home: {
      eyebrow: "Quantum Capital Management",
      title: "Luxembourg AIFM",
      subtitle: "Alternative Investment Fund Management",
      alt: "Luxembourg Kirchberg financial district at civil blue hour"
    },
    services: {
      eyebrow: "Services",
      title: "Services",
      subtitle: "Institutional investment management",
      alt: "Cool blue-grey Luxembourg financial district architecture at blue hour"
    },
    legal: {
      eyebrow: "Legal & Regulatory",
      title: "Legal",
      subtitle: "Legal & Regulatory Information",
      alt: "European institutional courthouse interior — marble colonnade in cool blue-grey grade"
    },
    contact: {
      eyebrow: "Contact",
      title: "Contact",
      subtitle: "Registered office and enquiries",
      alt: "Institutional executive overlooking a European financial district at first light"
    }
  },
  menu: {
    open: "Menu",
    close: "Close",
    navigate: "Navigate",
    language: "Language",
    lang_note: "The full site is currently being translated. Draft French and German versions are available for review.",
    entity: "Quantum Capital Management S.A.",
    nav: {
      home: "Home",
      services: "Services",
      legal: "Legal",
      contact: "Contact"
    }
  },
  home: {
    eyebrow: "Luxembourg",
    h1_l1: "Quantum Capital",
    h1_l2: "Management S.A.",
    hero_sub: "Luxembourg Alternative Investment Fund Manager",
    reg_eyebrow: "Regulatory Status",
    reg_body: "Quantum Capital Management S.A. is a Luxembourg-based Alternative Investment Fund Manager serving institutional investment structures through governance, portfolio management, risk management and regulatory oversight.",
    services_eyebrow: "Services",
    services_h2: "Governance, portfolio management, risk and regulatory oversight.",
    framework_eyebrow: "Institutional Framework",
    framework_body: "Luxembourg's regulatory architecture — anchored in the Law of 12 July 2013 and Directive 2011/61/EU — provides one of Europe's most established frameworks for alternative investment fund management. The Company operates within this regime under the ongoing supervision of the CSSF, in the interest of the investors and structures it serves.",
    framework_image_alt: "Long empty European institutional corridor with wide oak floor and tall windows",
    close_image_alt: "Luxembourg old town rooftops at deep blue hour",
    mid_alt: "Architectural detail — a marble column with a brass edge in soft morning light",
    bluehour_alt: "Luxembourg old town rooftops at deep blue hour",
    footprint_eyebrow: "Global Footprint",
    footprint_h2: "A Luxembourg base connected to institutional counterparties worldwide.",
    footprint_body: "From its regulated base in Luxembourg, the Company works alongside institutional investors, funds, service providers and regulators across a defined set of jurisdictions.",
    footprint_map_alt: "World map with markers in Luxembourg, France, Germany, the United States, China, Qatar and the United Arab Emirates.",
    footprint_caption: "Illustrative — jurisdictions of institutional relationships",
    footprint_countries: {
      united_states: "United States",
      luxembourg: "Luxembourg",
      france: "France",
      germany: "Germany",
      china: "China",
      qatar: "Qatar",
      uae: "United Arab Emirates"
    }
  },
  contact_map: {
    eyebrow: "Presence",
    heading: "Where we operate",
    subtitle: "The Company maintains institutional relationships across principal financial centres.",
    map_alt: "World map indicating Luxembourg, Frankfurt, Zurich, Paris, Doha, Dubai and Shanghai.",
    caption: "Illustrative — principal jurisdictions of activity",
    countries: {
      luxembourg: "Luxembourg",
      germany: "Germany",
      switzerland: "Switzerland",
      france: "France",
      qatar: "Qatar",
      uae: "United Arab Emirates",
      china: "China"
    }
  },
  services_cards: {
    aifm: {
      eyebrow: "01 / Fund Management",
      title: "Alternative Investment Fund Management",
      line: "Management of alternative investment structures under Luxembourg AIFM law and Directive 2011/61/EU.",
      image_alt: "Abstract modern glass façade in soft morning light"
    },
    portfolio: {
      eyebrow: "02 / Portfolio",
      title: "Portfolio Management",
      line: "Disciplined oversight aligned with each fund's investment policy and fiduciary responsibilities.",
      image_alt: "Institutional interior detail — desk and quiet leather-bound volumes"
    },
    risk: {
      eyebrow: "03 / Risk",
      title: "Risk Management",
      line: "Independent framework covering market, liquidity, counterparty and operational risks.",
      image_alt: "Architectural line study — colonnade with repeated stone forms"
    },
    governance: {
      eyebrow: "04 / Governance",
      title: "Governance & Regulatory Oversight",
      line: "Corporate governance, CSSF reporting, compliance and delegation monitoring.",
      image_alt: "Long institutional corridor with pale limestone floor"
    }
  },
  services_page: {
    eyebrow: "Services",
    h1: "Services",
    intro: "Regulatory management, portfolio oversight, risk and governance for Luxembourg alternative investment structures.",
    hero_alt: "Quiet minimalist European institutional interior",
    detail_alt: "Institutional interior corridor detail — marble floor and timber panelling",
    sections: {
      aifm: {
        number: "01",
        title: "Alternative Investment Fund Management",
        body: "Management of alternative investment structures in accordance with applicable Luxembourg regulation, including the Luxembourg Law of 12 July 2013 on alternative investment fund managers and Directive 2011/61/EU (AIFMD)."
      },
      portfolio: {
        number: "02",
        title: "Portfolio Management",
        body: "Disciplined portfolio oversight aligned with each fund's investment objectives, investment policy and fiduciary responsibilities, exercised in the interest of investors."
      },
      risk: {
        number: "03",
        title: "Risk Management",
        body: "Independent risk management framework covering market, liquidity, counterparty and operational risks, supporting prudent investment oversight consistent with AIFMD requirements."
      },
      governance: {
        number: "04",
        title: "Governance & Regulatory Oversight",
        body: "Corporate governance, regulatory reporting to the CSSF, compliance oversight, delegation monitoring and operational supervision of the management company's activities."
      }
    }
  },
  contact: {
    eyebrow: "Contact",
    h1: "Contact",
    intro: "For professional and institutional enquiries.",
    header_alt: "Empty refined European boardroom in soft daylight",
    office_heading: "Registered Office",
    office_address_line1: "1 Haaptstrooss",
    office_address_line2: "L-9806 Hosingen, Luxembourg",
    office_address_placeholder: "1 Haaptstrooss, L-9806 Hosingen, Luxembourg",
    labels: {
      rcs: "RCS Luxembourg",
      rcs_value: "B215925",
      lei: "LEI",
      lei_value: "984500BA00891BF49F35",
      email: "Email",
      telephone: "Telephone",
      placeholder: "[Placeholder]"
    },
    form: {
      contacting_as: "I am contacting as",
      first_name: "First name",
      last_name: "Last name",
      organisation: "Organisation",
      email: "Professional email",
      country: "Country",
      subject: "Subject",
      message: "Message",
      submit: "Send enquiry",
      sending: "Sending…",
      select_prompt: "Select…",
      required_star: "*",
      char_count: "{count} / 5000",
      consent_prefix: "I have read the ",
      consent_link: "Privacy Notice",
      consent_suffix: " and consent to the processing of my personal data for the purpose of responding to my enquiry.",
      errors: {
        required: "Required.",
        category: "Please select a category.",
        email: "Enter a valid email address.",
        message_min: "Please provide at least 20 characters.",
        message_max: "Maximum 5000 characters.",
        consent: "Consent is required to submit this form.",
        rate_limit: "Too many submissions from this location. Please try again later.",
        generic: "Your enquiry could not be submitted. Please try again.",
        network: "A network error occurred. Please try again."
      },
      categories: {
        institutional_investor: "Institutional Investor",
        investment_fund: "Investment Fund",
        regulator: "Regulator",
        service_provider: "Service Provider",
        business_partner: "Business Partner",
        general_enquiry: "General Enquiry"
      },
      helper: {
        regulator: "Regulatory correspondence will be routed to the appropriate function."
      }
    },
    success: {
      title: "Thank you.",
      body: "Your enquiry has been received. A member of the team will respond shortly.",
      reset: "Send another enquiry"
    }
  },
  legal: {
    eyebrow: "Legal",
    h1: "Legal and regulatory information",
    last_updated_label: "Last updated",
    toc_label: "Contents",
    toc_mobile_label: "Contents",
    section_titles: {
      "legal-notice": "Legal Notice",
      "regulatory-information": "Regulatory Information",
      "privacy": "Privacy Notice",
      "cookies": "Cookie Policy",
      "complaints": "Complaints Handling",
      "conflicts": "Conflicts of Interest",
      "remuneration": "Remuneration Policy",
      "sfdr": "Sustainability (SFDR)",
      "disclaimer": "Disclaimer"
    }
  },
  footer: {
    tagline: "Luxembourg Alternative Investment Fund Manager",
    links: {
      legal_notice: "Legal Notice",
      privacy: "Privacy Notice",
      cookies: "Cookie Policy",
      contact: "Contact"
    },
    group_line: "A member of the Quantum Group",
    copyright: "© {year} Quantum Capital Management S.A. · Luxembourg"
  },
  cookie: {
    copy_prefix: "This website uses only essential cookies necessary for its operation. For further information, please refer to our ",
    policy_link: "Cookie Policy",
    copy_suffix: ".",
    dismiss: "Dismiss"
  },
  draft: {
    text: ""  // en does not display a draft banner
  }
};
export default en;
